/**
 * TierBreakdownBar — kademe başına geçen kullanıcı sayısını görsel olarak
 * gösterir. Görev listesi ve dashboard'da BİREBİR AYNI gösterim kullanılır
 * (müşteri talebi: 2026-05-14).
 *
 * Veri formatı (backend `tier_breakdown` field'ı):
 *   [{ tier_id, threshold_value, points, user_count }, ...]
 *
 * Cumulative semantik: user_count = bu eşiği geçen distinct kullanıcı sayısı
 * (raw_value ≥ threshold). En düşük eşikte sayı en yüksek; en yüksek eşikte
 * en az (huni şekli).
 *
 * Görsel: yatay zincir — her tier bir "pill"; içinde eşik + puan + sayı.
 * Renk yoğunluğu user_count oranıyla ilişkili (yeşil → amber → gri → soluk).
 * Table cell + Dashboard kart, ikisinde de aynı bileşen, aynı style.
 */
export default function TierBreakdownBar({ tiers, maxUsers }) {
  if (!Array.isArray(tiers) || tiers.length === 0) {
    return (
      <span className="text-[10px] text-neutral-400 italic">
        Kademe verisi yok
      </span>
    );
  }

  // En yüksek user_count'u referans al — renk gradient'i için
  const top = maxUsers ?? Math.max(1, ...tiers.map((t) => t.user_count || 0));

  const intensityClass = (cnt) => {
    if (top <= 0) return 'bg-neutral-50 text-neutral-400 border-neutral-200';
    const ratio = (cnt || 0) / top;
    if (ratio >= 0.66) return 'bg-emerald-100 text-emerald-900 border-emerald-300';
    if (ratio >= 0.33) return 'bg-amber-100 text-amber-900 border-amber-300';
    if (ratio > 0)     return 'bg-neutral-100 text-neutral-700 border-neutral-300';
    return 'bg-neutral-50 text-neutral-400 border-neutral-200';
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {tiers.map((t, idx) => (
        <span
          key={t.tier_id ?? idx}
          className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md border text-[11px] tabular-nums ${intensityClass(t.user_count)}`}
          title={`Eşik ≥ ${t.threshold_value} → ${t.points} puan · ${t.user_count} kullanıcı`}
        >
          <span className="opacity-70">≥{t.threshold_value}</span>
          <span className="text-[10px] opacity-50">·</span>
          <span className="font-semibold">{t.user_count ?? 0}</span>
          <span className="text-[10px] opacity-60">kişi</span>
        </span>
      ))}
    </div>
  );
}
